<!-- 品质流量 -->
<template>
    <div class="advantage_wrapper">
        <!-- part1 -->
        <div class="section_item advantage_section1 platform_section1">
            <div class="wrapper">
                <div class="block">
                    <div class="title">{{section1.title}}</div>
                    <div class="description">{{section1.description}}</div>
                    <el-button @click="bind_toggle_form('cooperation')" type="warning" class="btn_init">{{section1.cta}}</el-button>    
                </div> 
                <img :src="section1.link">
            </div>
        </div>
        <!-- part2 -->
        <div class="section_item advantage_section2">
            <div class="title_wrapper_fade">
                <div class="title_wrapper">
                    <div class="title">{{section2.name}}</div>
                    <div class="description">{{section2.desc}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div class="lists_wrapper">
                <div v-for="(item, idx) in section2.data || []"
                    :key="idx"
                    class="list_wrapper"
                    :style="{paddingRight: idx === 3 ? 0 : '33px'}">
                    <img :src="item.link" alt="">
                    <div class="app_wrapper">
                        <div class="title">{{item.title}}</div>
                        <div class="description">{{item.description}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- part3 -->
        <div class="section_item advantage_section3">
            <div class="title_wrapper_fade">
                <div class="title_wrapper">
                    <div class="title">{{section3.name}}</div>
                    <div class="description">{{section3.desc}}</div>
                    <div class="underline"></div>
                </div>
            </div>
            <div class="tags_wrapper">
                <div v-for="(item, idx) in section3.data || []"
                    :key="idx"
                    class="tag_wrapper"
                    :style='{width: ((1/section3.data.length)*1280)+"px"}'>
                    <div class="icon"><img :src="item.link"></div>
                    <div class="num">{{item.num}}<span>+</span></div>
                    <div class="tag">{{item.tag}}</div>
                </div>
            </div>
        </div>
         <!-- part4 -->
        <div class="section_item advantage_section4 platform_image_text">
            <div v-for="(item, idx) in section4.data || []"
                :key="idx"
                class="show_wrapper">
                <div class="show_content">
                    <div class="title_en">{{item.title_en}}</div>
                    <div class="title">{{item.title}}</div>
                    <div class="underline"></div>
                    <div class="description">{{item.description}}</div>
                </div>
                <div :style="{float: item.pos}" 
                    class="show_img"><img class="show_img_tag" :src="item.link" alt=""></div>
            </div>
        </div>
        <div class="section_item advantage_section5">
            <div class="form_wrapper">
                <CmsForm/>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/advantage.js';
    export default {
        name: "Index",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            section1() {
                return data.flow && data.flow.section1;
            },
            section2() {
                return data.flow && data.flow.section2;
            },
            section3() {
                return data.flow && data.flow.section3;
            },
            section4() {
                return data.flow && data.flow.section4;
            }
        },
        mounted() {

        },
        methods: {
            // 显示合作/登录组件
            bind_toggle_form(flag) {
                // 百度统计
                window._hmt.push(['_trackEvent', 'ctaTrigger', 'advantage_traffic', flag]);
                this.$emit('toggleForm', flag);
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .advantage_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
    }

    /* 第一部分的样式 */
    .advantage_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
    }
     /* 第二部分的样式 */
    .advantage_section2 {
        background: #fff;
        height: auto;
    }
    /* 标题包裹狂 */
    .advantage_section2 .title_wrapper_fade {
        width: 1280px;
        margin: 0 auto;
        margin-top: 130px;
    }
    /* 列表包裹狂 */
    .advantage_section2 .lists_wrapper {
        width: 1280px;
        font-size: 0;
        margin: 80px auto 87px auto;
    }
    
    .advantage_section2 .list_wrapper {
        display: inline-block;
        text-align: center;
        margin-bottom: 64px;
        width: 33%;
        padding: 0 33px;
    }
    /* 资源具体icon */
    .list_wrapper img {
        float: left;
        width: 64px;
        height: 64px;
    }
    /* 资源具体描述 */
    .list_wrapper .app_wrapper {
        float: left;
        margin-left: 16px;
        text-align: left;
    }

    .app_wrapper .title {
        font-size: 18px;
        font-weight: bold;
        color: #18253D;
        line-height: 18px;
        margin: 9px 0 8px 0;
    }

    .app_wrapper .description {
        font-size: 14px;
        color: #636770;
        line-height: 21px;
    }
    /* 第三部分的样式 */
    .advantage_section3 {
        background: #FAFCFF;
        height: auto;
    }
    /* 标题包裹狂 */
    .advantage_section3 .title_wrapper_fade {
        width: 1280px;
        margin: 0 auto;
        margin-top: 146px;
    }
    /* 标签包裹框 */
    .advantage_section3 .tags_wrapper {
        width: 1280px;
        margin: 77px auto 147px auto;
    }
    /* 单独标签包裹框 */
    .tags_wrapper .tag_wrapper {
        display: inline-block;
    }
    /* icon样式 */
    .tag_wrapper .icon {
        margin: auto;
        width: 40px;
        height: 40px;
    }
    /* 数字样式 */
    .tag_wrapper .num {
        font-size: 52px;
        color: #18253D;
        line-height: 58px;
        border-right: 1px solid #e6e6e6;
        margin-top: 30px;
        padding-bottom: 18px;
    }

    .num span {
        vertical-align: top;
        font-size: 16px;
        color: #18253D;
        line-height: 24px;
    }
    /* 描述样式 */
    .tag_wrapper .tag {
        font-size: 14px;
        color: #A9AEB8;
        letter-spacing: 0;
        line-height: 14px;
        border-right: 1px solid #e6e6e6;
    }

    .tag_wrapper:last-child .tag, .tag_wrapper:last-child .num {
        border-right: 0px;
    }
     /* 第四部分的样式 */
    .advantage_section4 {
        background: #fff;
    }

    /* .advantage_section4 .show_img_tag {
        position: relative !important;
        width: 100% !important;
        height: 100% !important;
    } */
     /* 第五部分的样式 */
    .advantage_section5 {
        background: #FAFCFF;
        height: auto;
    }

    /* 标题包裹狂 */
    .advantage_section5 .form_wrapper {
        width: 1280px;
        margin: 48px auto 54px auto;
    }

</style>





// WEBPACK FOOTER //
// src/containers/Advantage/Flow.vue